import { action, makeObservable, observable } from 'mobx';
import ApiService from "src/services/apiService";
import { MasterWorkout, MasterWorkoutLookups, MasterWorkoutMax, programTypes } from "src/types/MasterWorkout";
import MasterWorkoutExerciseListViewModel from './MasterWorkoutExerciseListViewModel';

export default class MasterWorkoutViewModel {
	public masterWorkout: MasterWorkout = {
		id: null,
		name: null,
		previousName: null,
		description: null,
		permalink: null,
		weeks: null,
		daysPerWeek: null,
		thumbnailId: null,
		thumbnailUrl: null,
		enableMains: null,
		enableMainAlts: null,
		enableRetest: null,
		retestWeekDuration: null,
		tags: [],
		weightSelection: null,
		programType: null,
		difficultyRating: null,
		workoutType: [],
		sessionTime: null,
		focusedMuscleGroups: [],
		author: null,
		authorId: null,
		isNew: true,
		isPublic: null,
		createdBy: null,
		searchKeywords: null,
		publishedDate: null
	}
	public masterWorkoutExerciseListViewModel: MasterWorkoutExerciseListViewModel

	// Lookups
	public lookups: MasterWorkoutLookups = {
		authors: [],
		focusedMuscleGroups: [],
		groupTerms: [],
		masterExercises: [],
		sessionTimes: [],
		tags: [],
		weightSelections: [],
		workoutTypes: [],
		difficultyRatings: [],
		programTypes: [],
	}

	constructor(private service: ApiService) {
		makeObservable<MasterWorkoutViewModel>(this, {
			masterWorkout: observable,
			submitMasterWorkout: action,
			fetch: action,
			getMasterWorkoutLookups: action,
			// maxes
			addWorkoutMax: action,
			removeWorkoutMax: action,
			editWorkoutMax: action,
			// lookups
			lookups: observable,
		})

		this.masterWorkoutExerciseListViewModel = new MasterWorkoutExerciseListViewModel(service)
	}

	public fetch = (id: string): Promise<void> => {
		return this.service.getMasterWorkout(id).then((res) => {
			this.masterWorkout = res
			this.masterWorkoutExerciseListViewModel.setMasterWorkout(res)
		})
	}

	public getMasterWorkoutLookups = (): Promise<void> => {
		return this.service.getMasterWorkoutLookups().then((res) => {
			this.lookups = { ...res, difficultyRatings: ['1', '2', '3', '4', '5'], programTypes: programTypes }
		})
	}

	public submitMasterWorkout = (value: MasterWorkout): void => {
		Object.assign(this.masterWorkout, value)
		console.log('@ApiService->submitMasterWorkoutExercise', this.masterWorkout)
	}

	public saveChanges = (): Promise<number> => {
		// don't save master workout maxes when enableMains is unchecked
		return this.service.submitMasterWorkout({ ...this.masterWorkout })
	}

	public saveWorkoutMaxes = (): Promise<number> => {
		const { id, masterWorkoutMaxes } = this.masterWorkout;
		return this.service.submitMasterWorkoutMaxes({ masterWorkoutId: id, masterWorkoutMaxes });
	}

	public validateMasterWorkout = (values: MasterWorkout) => {
		const errors: any = {}
		if (!values.name) {
			errors.name = 'Required'
		}
		return errors
	}

	public deleteMasterWorkout = (): Promise<boolean> => {
		return this.service.deleteMasterWorkout(this.masterWorkout.id)
	}

	/**
	 * ************************************************
	 *  Master Workout Maxes
	 * ************************************************
	 */
	public addWorkoutMax = (): void => {
		this.masterWorkout.masterWorkoutMaxes = [
			...this.masterWorkout.masterWorkoutMaxes,
			{
				id: null,
				masterExerciseId: null,
				groupTermIds: [],
			},
		]
		console.log('@ApiService->addWorkoutMax')
	}

	public removeWorkoutMax = (idx: number): void => {
		const newArray = [...this.masterWorkout.masterWorkoutMaxes]
		newArray.splice(idx, 1)

		this.masterWorkout.masterWorkoutMaxes = newArray
		console.log('@ApiService->removeWorkoutMax')
	}

	public editWorkoutMax = (idx: number, value: MasterWorkoutMax): void => {
		const newArray = [...this.masterWorkout.masterWorkoutMaxes]
		newArray[idx] = value
		this.masterWorkout.masterWorkoutMaxes = newArray
		console.log('@ApiService->editWorkoutMax', idx, value)
	}
}